export const AB_TEST_PREFIX = 'ab_';

export const A_VERSION = 'A';
export const B_VERSION = 'B';

export const CURRENT_RUNNING_TEST = undefined;
